import { numberFormat } from "../../../util/currency-formatter";
import { Link } from "react-router-dom";
import { PURCHASE_ORDER, SUPPLIERS } from "../../../constants/route-paths";

export const createPOFields = {
    workType: {
        name: "workType",
        value: "",
        error: false,
        items: [{ key: "Project", value: "project" }],
        type: "select",
        valid: true,
        validation: [],
    },
    project: {
        name: "project",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        validation: ["required"],
    },
    tasksList: {
        name: "tasksList",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        validation: ["optional"],
    },
    vendor: {
        name: "vendor",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        validation: ["required"],
    },
    deliveryOption: {
        name: "deliveryOption",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        validation: ["optional"],
    },
    deliveryDate: {
        name: "deliveryDate",
        value: "",
        error: false,
        items: [],
        type: "datepicker",
        valid: true,
        validation: ["optional"],
    },
    notes: {
        name: "notes",
        value: "",
        error: false,
        items: [],
        type: "textarea",
        valid: true,
        validation: ["optional"],
    },
    street_address: {
        name: "street_address",
        label: "Street Address",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: ["required"],
    },
    suburb: {
        name: "suburb",
        label: "Suburb",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: ["required"],
    },
    state: {
        name: "state",
        label: "State",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: ["required"],
    },
    postcode: {
        name: "postcode",
        label: "Postcode",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: ["required"],
    },
    country: {
        name: "country",
        label: "Country",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: ["required"],
    },
}

export const poListColumns = [
    {
        title: "PO Number",
        field: "id",
        dataCy: "po-no",
        render: (rowData) => (
            <Link to={`/${SUPPLIERS}/${PURCHASE_ORDER}/view/${rowData.poId}/project`}>
                {/* f_id is the PO number with project prefix and Suffix if null then default to po Number*/}
                {rowData.f_id || rowData.id}
            </Link>
        ),
    },
    { title: "Vendor", field: "vendorName" , dataCy: "vendor-name"},
    {
        title: "Invoice Type",
        field: "invoiceType",
        render: (rowData) => rowData.is_credit_invoice ? "Credit" : "Regular"
    },
    // {
    //   title: "Vendor Type",
    //   field: "type",
    //   render: (rowData) =>
    //     rowData.type === "Supplier" ? "Supplier" : "Contractor",
    // },
    {
        title: "PO Address",
        field: "address",
        dataCy: "po-address",
    },
    {
        title: "Project",
        field: "project",
        dataCy: "project",
    },
    { title: "Issue Date", field: "issueDate" },
    {
        title: "Total",
        field: "total",
        class: 'text-right',
        dataCy: "total",
        render: (rowData) => {
            const amount = rowData.is_credit_invoice
                ? (rowData.receive_credit_amount ?? rowData.total)
                : rowData.total;
            const formatted = numberFormat(amount);
            return `${formatted}`;
        },
    },
    {
        title: "Status",
        field: "status",
        dataCy: "status",
        render: (rowData) => {
            if (rowData.is_credit_invoice) return '';
            let className = '';
            if (rowData.status === 'Active' || rowData.status === 'Pending') className = 'text-warning';
            else if (rowData.status === 'Inactive' || rowData.status === 'Completed') className = 'text-success';
            else if (rowData.status === 'Cancelled') className = 'text-danger';

            return <span className={className}>{rowData.status}</span>;
        },
    },
]